export enum IPublicEnumPluginRegisterLevel {
  Default = 'default',
  Workspace = 'workspace',
  Resource = 'resource',
  EditorView = 'editorView',
}